// React
import React, {Component} from 'react';
// Icon
import {searchSvg} from '@assets';
// Components
import {TextField, InputAdornment} from '@material-ui/core';
// Styles
import {withStyles} from '@material-ui/core/styles';
import '../styles.scss';

const useStyles = {
    formControl: {
        width: (props) => props.width ? props.width : 200,
        marginTop: 16
    },
    inputLabel: {
        color: '#565671',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        display: 'ruby',
        textAlign: 'left'
    }
}

class Search extends Component {

    render() {
        const {value, placeholder, onSearch, label, classes} = this.props;
        return (
            <div className={"platform_input_search"}>
                {
                    label &&
                    <label
                        className={`${classes.inputLabel} MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-shrink MuiFormLabel-filled`}
                        data-shrink="true">{placeholder}</label>
                }
                <TextField
                    onChange={(e) => onSearch(e, 'search')}
                    className={`platform_input platform_input__primary ${classes.formControl}`}
                    placeholder={placeholder && !label ? placeholder : ''}
                    value={value}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position={'end'}>
                                {searchSvg()}
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
        );
    }
}

export default withStyles(useStyles)(Search);
